import React from 'react';
import PropTypes from 'prop-types';

export function LiveRegion(props) {
  return (
    <div
      className={props.liveRegionClassName}
      aria-live={props['aria-live']}
      aria-label={props.screenReaderText}
      role={props.role}
    >
      {props.showText && props.screenReaderText}
    </div>
  );
}

LiveRegion.propTypes = {
  liveRegionClassName: PropTypes.string,
  'aria-live': PropTypes.oneOf(['off', 'polite', 'assertive']),
  role: PropTypes.string,
  screenReaderText: PropTypes.string,
  showText: PropTypes.bool,
};

LiveRegion.defaultProps = {
  liveRegionClassName: 'live-region',
  'aria-live': 'polite',
  role: 'region',
  screenReaderText: '',
  showText: false,
};
